import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";

const PaymentTermsForm = ({
  handleFormChange,
  errors,
  values,
  setValues,
  handleSubmit,
  loading,
}) => {

  const navigate = useNavigate();
  const handleRedirect = () => {
    setValues({});
    navigate("/payment-terms");
  };


  const location = useLocation();

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
      detail: {
        pathname: location.pathname,
        title: values?.id ? "Edit Payment Term" : "New Payment Term",
        backTarget: { pathname: "/payment-terms" },
      },
    }));

    return () => {
      window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
        detail: {
          pathname: location.pathname,
          clear: true,
        },
      }));
    };
  }, [values?.id, location.pathname]);

  return (
    <>
    <div class="card">
      <div className="card-body">
        <div className="card">
          <div className="card-header">
            <h2>General Information</h2>
          </div>
          <div className="card-body bg-white">
            <div className="row">
              <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-12 col-xs-12 mb-2">
                <div>
                  <label>
                    Payment Terms <span className="mandatory">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={PlaceHolder?.PAYMENT_TERMS}
                    name="paymentDescription"
                    value={values?.paymentDescription}
                    onChange={handleFormChange} />
                  {errors.paymentDescription && (
                    <p className="form-error">{errors.paymentDescription}</p>
                  )}
                </div>
              </div>
              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-2">
                <div>
                  <label>
                    Credit Days <span className="mandatory">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={PlaceHolder?.PAYMENT_TERMS}
                    name="creditDays"
                    value={values?.creditDays}
                    onChange={handleFormChange} />
                  {errors.creditDays && (
                    <p className="form-error">{errors.creditDays}</p>
                  )}
                </div>
              </div>
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                <div>
                  <label>Description</label>
                  <textarea
                    className="form-control"
                    name="paymentTooltip"
                    placeholder={PlaceHolder?.DESCRIPTION}
                    rows="5"
                    value={values?.paymentTooltip}
                    onChange={handleFormChange}
                  ></textarea>
                </div>
                {errors.paymentTooltip && (
                  <p className="form-error">{errors.paymentTooltip}</p>
                )}
              </div>
              {values?.id && (
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                  <div className="ml-1">
                    <label>
                      Status <span className="mandatory">*</span>
                    </label>
                    <div class="form-group mb-0 mt-n3">
                      <input
                        className="input-checkbox"
                        type="checkbox"
                        id="isActive"
                        name="isActive"
                        value={values?.isActive}
                        checked={values?.isActive}
                        onChange={handleFormChange}
                        disabled={!values?.id} />
                      <label className="mb-0 check-box-label" for="isActive">
                        {values?.isActive ? "Active" : "Inactive"}{" "}
                      </label>
                    </div>
                  </div>
                </div>
              )}
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                <div class="form-group ml-1">
                  <input
                    className="input-checkbox"
                    type="checkbox"
                    id="requiredCreditCheck"
                    name="requiredCreditCheck"
                    value={values?.requiredCreditCheck}
                    checked={values?.requiredCreditCheck}
                    onChange={handleFormChange} />
                  <label
                    className="mb-0 check-box-label"
                    for="requiredCreditCheck"
                  >
                    Credit Check Required <span className="mandatory">*</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- add-new-sec ends --> */}
        <div className="row mt-3 mb-3">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 my-auto">
            <div className="save-btns d-flex justify-content-end">
              <button className="btn cancel-btn" onClick={handleRedirect}>
                {" "}
                Cancel
              </button>
              <button
                className="btn save-btn"
                onClick={handleSubmit}
                disabled={loading}
              >
                {" "}
                {values?.id ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
      </>
  );
};

export default PaymentTermsForm;
